import { MenuItemProcessingRule } from '../interfaces';
import { getUnavailableProductIds } from '@core/domain/availability';

export const menuItemServiceAvailabilityRule: MenuItemProcessingRule = context => {
	const unavailableIds = new Set(getUnavailableProductIds(context.availabilities, context.now));

	return {
		...context,
		items: context.items.filter(item => !unavailableIds.has(item.idArticulo)),
	};
};
